import { useAbTestComponent, loadLazyComponent } from "@hook";
import { inject, observer } from "mobx-react";

import Default from "./Default";

const abTests = {
    dev_3274__v2: loadLazyComponent(() => import("./AB_3274")),
    dev_3632__v2: loadLazyComponent(() => import("./AB_3274")),
};

const Footer = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default Footer;
